<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card>
            <template slot="header">
              <h4 class="card-title">Banner</h4>
              <p class="card-category">{{state.banner.name}}</p>
            </template>
            <form>
              <div class="row">
                <div class="col-md-6">
                  <base-input
                    type="text" label="Banner Name" placeholder="Banner Name"
                    v-model="state.banner.name"
                    id="name" v-on:blur="onBlur($event)" v-bind:valid="$v.name"
                    tip="A short name (1 - 3 words) used to describe this banner."
                  >
                  </base-input>
                </div>
                <div class="col-md-6">
                  <base-input
                    type="text" label="Position" placeholder="center 33%"
                    v-model="state.banner.position"
                    id="position" v-on:blur="onBlur($event)" v-bind:valid="$v.position"
                    tip="CSS style for background-position, typically center nn%."
                  >
                  </base-input>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <base-textarea
                    label="Lead Text" placeholder="Lead text" rows="5"
                    v-model="state.banner.lead"
                    id="lead" v-on:blur="onBlur($event)" v-bind:valid="$v.lead"
                  >
                  </base-textarea>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <base-input
                    label="Banner Image"
                    tip="The banner"
                  >
                    <image-editor
                      v-model="state.banner.bannerUrl"
                      :storage="state.upload.storage"
                    ></image-editor>
                  </base-input>
                </div>
              </div>

              <div class="text-left">
                <button type="submit" class="btn btn-fill btn-primary" @click.prevent="onSaveClick">
                  Update Banner
                </button>
              </div>

            </form>
            <!-- <div class="clearfix"></div> -->
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, reactive, ref, watch } from '@vue/composition-api'
import { What, Verb, can }  from '@/rights/rights.js'
import graphql from '@/api/graphql'
import gql from 'graphql-tag'
import router from '@/routes/router'
import { useValidator } from 'src/components/validator.js'
import ImageEditor from '@/components/Forms/ImageEditor.vue'

export default {
  components: {
    ImageEditor
  },
  setup(props, context) {
    const store = context.root.$store
    const routeparams = context.root.$route.params
    const state = reactive({
        banner: {},
        upload: {
          storage: {
            domain: 'banner',
            id: '',
            what: 'image'
          }
        }
    });
    watch(
      () => context.root.$route.params,
      (to, from) => {
      // console.log('route changed', to, from)
      refresh(to.bannerId)
    })
    function refresh(bannerId) {
      let graphQuery = gql`query Banner($id: ID) {
        banner(id: $id) {
          id
          name
          lead
          position
          bannerUrl
        }
      }`
      graphql.query(graphQuery, {
        id: bannerId
      })
      .then(json => {
        state.banner = json.data.banner
        state.upload.storage.id = state.banner.id
      })
      .catch(gqlResponse => {
        graphql.handleError(gqlResponse, 'Error getting banner:', store.dispatch)
      })
    }

    const $v = useValidator({
      name: {
        presence: { allowEmpty: false },
        length: { minimum: 3 }
      },
    })
    function onBlur(e) {
      console.log('onblur')
      $v.validateEvent(e)
    }

    function onSaveClick() {
      const isValid = $v.validateAll(state.banner)
      if (isValid) {
        // store.dispatch('userUpdateProfile', user)
        let graphQuery = gql`mutation Banner($input: BannerInput!) {
          banner(input: $input) {
            id
            name
            lead
            position
            bannerUrl
          }
        }`
        let id0 = state.banner.id
        // console.log('id', id0)
        graphql.query(graphQuery, {
          input: state.banner
        })
        .then(json => {
          state.banner = json.data.banner
          store.dispatch('notify', { type: 'success', message: 'Banner updated'})
          if (id0 != state.banner.id) {
            router.push(`${process.env.BASE_URL}admin/banner/` + state.banner.id)
          }
        })
        .catch(gqlResponse => {
          graphql.handleError(gqlResponse, 'Error updating banner:', store.dispatch)
        })

      }
    }

    return {
      state,
      onSaveClick,
      '$v': $v.model,
      onBlur
    }
  }
}
</script>
<style lang="scss">
</style>